module.exports = __webpack_public_path__ + "b64726af.svg";